meedy.controller('meedy.secondDiagnosisEditController', ['$scope', '$state', '$stateParams', '$mdToast', '$mdDialog', '$translate', 'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.secondDiagnosisModel',
	function ($scope, $state, $stateParams, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, secondDiagnosisModel) {

		function setData() {
			$scope.secondDiagnosis = new SecondDiagnosisMeedyVO();
			$scope.executionWrapper = new SecondDiagnosisExecutionWrapperVO();
			$scope.generalInterviewSelected = true;
			$scope.files = [];
			$scope.ableToEdit = false;
			$scope.presentDate = new Date();
			
			$scope.forms = {
				secondDiagnosis: null
			}
		}

		function setPermissions() {
		}

		function setListeners() {
			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.GET_BY_ID.SUCCESS, function(event, secondDiagnosis) {
				$scope.secondDiagnosis = secondDiagnosis;
				$scope.executionWrapper.diagnosis = secondDiagnosis.diagnosis;
				$scope.executionWrapper.result1Number = secondDiagnosis.result1Number;
				$scope.executionWrapper.result1Date = secondDiagnosis.result1Date;
				$scope.executionWrapper.result1Place = secondDiagnosis.result1Place;
				$scope.executionWrapper.result2Number = secondDiagnosis.result2Number;
				$scope.executionWrapper.result2Date = secondDiagnosis.result2Date;
				$scope.executionWrapper.result2Place = secondDiagnosis.result2Place;
				$scope.executionWrapper.result3Number = secondDiagnosis.result3Number;
				$scope.executionWrapper.result3Date = secondDiagnosis.result3Date;
				$scope.executionWrapper.result3Place = secondDiagnosis.result3Place;
				$scope.ableToEdit = secondDiagnosis.status == Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.VALIDATED
				|| secondDiagnosis.status == Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.IN_PROGRESS;

				if(secondDiagnosis.status == Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.VALIDATED) {
					secondDiagnosisModel.startWork($stateParams.id);
				}

			});

			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.GET_ATTACHMENTS.SUCCESS, function (event, files) {
				$scope.files = files;
				$scope.deletedFile = null;

				$scope.files.forEach(function(file) {
					file.selected = true;
				});
			});

			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.TOKEN.SUCCESS, function(event, token) {
				secondDiagnosisModel.downloadPDF(token);
			});

			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.SAVE_OR_UPDATE.SUCCESS, function(event, secondDiagnosis) {
				$scope.secondDiagnosis = secondDiagnosis;
				$scope.executionWrapper.diagnosis = secondDiagnosis.diagnosis;
				$scope.ableToEdit = secondDiagnosis.status == Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.VALIDATED
															|| secondDiagnosis.status == Enum.MEEDY.SECOND_DIAGNOSIS_STATUS.IN_PROGRESS;
			});

			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.EXECUTE.SUCCESS, function(event, secondDiagnosis) {
				$state.go(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST);
			});

			$scope.$on(Event.MEEDY.SECOND_DIAGNOSIS.REFUSE.SUCCESS, function(event, secondDiagnosis) {
				$state.go(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST);
			});

			$scope.$on('$destroy', function (event) {
				applicationModel.viewReady = false;
			});
		}

		function setActions() {
			$scope.downloadGeneralInterview = function() {
				secondDiagnosisModel.token($scope.secondDiagnosis.id);
			};

			$scope.refuse = function() {
				var refusalWrapper = new SecondDiagnosisRefusalWrapperVO();
				refusalWrapper.rejectionReason = '';

				secondDiagnosisModel.refuse($scope.secondDiagnosis.id, refusalWrapper);
			};

			$scope.refuseIncompetence = function() {
				var refusalWrapper = new SecondDiagnosisRefusalWrapperVO();
				refusalWrapper.rejectionReason = '';

				secondDiagnosisModel.refuseIncompetence($scope.secondDiagnosis.id, refusalWrapper);
			};

			$scope.downloadSelectedAttachments = function() {
				var wrapper = new SecondDiagnosisAttachmentIdWrapperVO();
				wrapper.idAttachments = [];

				if ($scope.generalInterviewSelected) {
					wrapper.idAttachments.push(0);
				}

				$scope.files.forEach(function(it) {
					if (it.selected) {
						wrapper.idAttachments.push(it.id)
					}
				})

				if (wrapper.idAttachments.length > 0) {
					secondDiagnosisModel.downloadSelectedAttachments($scope.secondDiagnosis.id, wrapper);
				}
			};

			$scope.execute = function() {
				$scope.forms.secondDiagnosis.$setSubmitted();
				
				if ($scope.forms.secondDiagnosis.$valid) {
					secondDiagnosisModel.execute($scope.secondDiagnosis.id, $scope.executionWrapper);
				}
			};

			$scope.saveWorkVersion = function() {
				secondDiagnosisModel.saveOrUpdate($scope.secondDiagnosis.id, $scope.executionWrapper);
			};

			$scope.openFile = function(file) {
				secondDiagnosisModel.downloadAttachment($scope.secondDiagnosis.id, file.id, file.fileName);
			};

			$scope.allowExtension = function (name) {
				var allow = false;
				var allowExt = ['pdf', 'jpg', 'jpeg', 'png', 'gif'];
				var ext = name.split('.').pop();

				if(allowExt.includes(ext)) {
					allow = true;
				}
				return allow;
			};
		}

		function configureInterface() {
			applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SECOND_DIAGNOSIS.LIST);

			var breadcrumbItems = [];
			applicationModel.setBreadcrumbItems(breadcrumbItems);
			applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.SECOND_DIAGNOSIS');
		}

		function initialize() {
			secondDiagnosisModel.getById($stateParams.id);
			secondDiagnosisModel.getAttachments($stateParams.id);

			applicationModel.viewReady = true;
		}

		setData();
		setPermissions();
		setListeners();
		setActions();
		configureInterface();
		initialize();
	}
]);
